import type { PersonnelEmploymentRecord } from '../personnelTypes';

/**
 * A post at THIS organization — the employment-history line names a plantilla item.
 *
 * Off the wire, so `!= null`: a previous employer's line OMITS the field rather than sending
 * null. Its own module because a file exporting a component and a function loses fast refresh.
 */
export function isPostHere(line: PersonnelEmploymentRecord): boolean {
  return line.plantillaItemId != null;
}
